import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full bg-background min-h-screen" }
const _hoisted_2 = { class: "w-full flex flex-row justify-end py-2 space-x-3 md:visible sm:visible container pt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Report ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  })
], -1)
const _hoisted_8 = { class: "flex flex-col lg:flex-row p-5 lg:container lg:space-x-8 py-8" }
const _hoisted_9 = { class: "bg-white p-4 lg:py-8 shadow-lg lg:shadow-none lg:card-main w-full lg:w-3/12 rounded-2xl h-full" }
const _hoisted_10 = { class: "flex flex-col w-full py-2 rounded-lg space-y-4" }
const _hoisted_11 = { class: "flex justify-end w-full lg:space-x-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY LOCATION ", -1)
const _hoisted_13 = { class: "space-y-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY STATUS ", -1)
const _hoisted_15 = { class: "space-y-3" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY MANAGED ", -1)
const _hoisted_18 = { class: "space-y-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY RECRUITER ", -1)
const _hoisted_20 = { class: "relative" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY CLIENT ", -1)
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "lg:w-9/12 w-full" }
const _hoisted_24 = { class: "w-full flex flex-row justify-end py-2 space-x-3 hidden md:hidden sm:hidden xs:hidden lg:visible" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Report ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  })
], -1)
const _hoisted_30 = { class: "w-full flex flex-col lg:flex-row justify-between items-center mt-3" }
const _hoisted_31 = { class: "w-full mt-2 lg:mt-0" }
const _hoisted_32 = { class: "flex flex-row justify-center lg:justify-end items-center lg:space-x-5 w-full lg:w-1/3" }
const _hoisted_33 = {
  key: 0,
  class: "w-full"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "w-full py-2"
}
const _hoisted_36 = {
  key: 3,
  class: "w-full flex flex-row justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_JobsEmptyState = _resolveComponent("JobsEmptyState")!
  const _component_JobCard = _resolveComponent("JobCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_AddTemplateToJob = _resolveComponent("AddTemplateToJob")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_AddRecruiterToJob = _resolveComponent("AddRecruiterToJob")!
  const _component_AddChallengeToJob = _resolveComponent("AddChallengeToJob")!
  const _component_CloseJob = _resolveComponent("CloseJob")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isInternalRecruiter)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "flex btn-outline-sm px-6 py-2 border-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args)))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(_component_Link, {
          to: "/create-job",
          variant: "contained",
          label: "Create job"
        }, {
          startIcon: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          label: "Back",
          variant: "outlined",
          onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router && _ctx.router?.push('/')))
        }, {
          startIcon: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "text-primary-dark text-md font-bold",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
              }, " Clear all "),
              _createElementVNode("button", {
                type: "button",
                class: "text-primary text-md font-bold",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchFilter && _ctx.searchFilter(...args)))
              }, " Apply ")
            ]),
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand.location = !_ctx.expand.location)),
              class: "flex flex-row justify-between items-center w-full"
            }, [
              _hoisted_12,
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-chevron-down text-gray-500", _ctx.expand.location && 'transform rotate-180 '])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (item, index) => {
                return (_openBlock(), _createBlock(_component_RadioButton, {
                  key: `radio-${item}-${index}`,
                  label: item,
                  value: item,
                  modelValue: _ctx.radioLocation,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.radioLocation) = $event))
                }, null, 8, ["label", "value", "modelValue"]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.expand.location]
            ]),
            _createVNode(_component_Divider, { height: "px" }),
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.expand.status = !_ctx.expand.status)),
              class: "flex flex-row justify-between w-full"
            }, [
              _hoisted_14,
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-chevron-down text-gray-500", _ctx.expand.status && 'transform rotate-180 '])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobStatus, (item, index) => {
                return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                  key: `item-checkbox-${index + 1}`,
                  fieldId: item.id,
                  names: _ctx.checkValues,
                  "onUpdate:names": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkValues) = $event)),
                  label: item.name,
                  value: item.id
                }, null, 8, ["fieldId", "names", "label", "value"]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.expand.status]
            ]),
            (!_ctx.isInternalRecruiter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_Divider, { height: "px" }),
                  _createElementVNode("div", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.expand.managed = !_ctx.expand.managed)),
                    class: "flex flex-row justify-between w-full"
                  }, [
                    _hoisted_17,
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down text-gray-500", _ctx.expand.managed && 'transform rotate-180 '])
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managedJobs, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: `radio-${item}-${index}`,
                        label: item.name,
                        value: item.id,
                        modelValue: _ctx.managedJob,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.managedJob) = $event))
                      }, null, 8, ["label", "value", "modelValue"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.managed]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Divider, { height: "px" }),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.internal,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.internal) = $event)),
                options: _ctx.internalList,
                label: "name",
                placeholder: "All recruiters",
                reduce: (name) => name.email
              }, null, 8, ["modelValue", "options", "reduce"])
            ]),
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.client,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.client) = $event)),
                options: _ctx.clientList,
                placeholder: "All clients",
                label: "name",
                reduce: (name) => name.id
              }, null, 8, ["modelValue", "options", "reduce"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (!_ctx.isInternalRecruiter)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "flex btn-outline-sm px-6 py-2 border-primary",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args)))
                }, _hoisted_27))
              : _createCommentVNode("", true),
            _createVNode(_component_Link, {
              to: "/create-job",
              variant: "contained",
              label: "Create job"
            }, {
              startIcon: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              label: "Back",
              variant: "outlined",
              onOnClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.router && _ctx.router?.push('/')))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_SearchInput, {
                modelValue: _ctx.inputValue,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.inputValue) = $event)),
                placeholder: "Start typing to search jobs...",
                onOnSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.searchFilter(_ctx.data)))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_Button, {
                class: "ml-6",
                variant: "",
                label: 
                _ctx.asc
                  ? 'Sort by last interaction (desc)'
                  : 'Sort by last interaction (asc)'
              ,
                onOnClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setAsc(!_ctx.asc)))
              }, null, 8, ["label"])
            ])
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_Loading, {
                  active: _ctx.isLoading,
                  "onUpdate:active": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isLoading) = $event)),
                  "can-cancel": false,
                  loader: "spinner",
                  color: "#8908F9",
                  width: 128,
                  height: 128,
                  "is-full-page": true
                }, null, 8, ["active"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.jobsStore && _ctx.jobsStore.jobs && _ctx.jobsStore.jobs.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_JobsEmptyState)
              ]))
            : _createCommentVNode("", true),
          (_ctx.jobsStore && _ctx.jobsStore.jobs && _ctx.jobsStore.jobs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_JobCard, {
                  jobs: _ctx.jobsStore.jobs,
                  showAssing: _ctx.isRecruiterAdmin,
                  onOpenTemplate: _ctx.openTemplate,
                  onOpenChallenge: _ctx.openChallenge,
                  onDeactivateJob: _ctx.deactivateJob,
                  onAssignJob: _ctx.assignJob
                }, null, 8, ["jobs", "showAssing", "onOpenTemplate", "onOpenChallenge", "onDeactivateJob", "onAssignJob"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.jobsStore && _ctx.jobsStore.jobs && _ctx.jobsStore.jobs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(_component_Paginator, {
                  modelValue: _ctx.page,
                  page: _ctx.page,
                  pages: _ctx.jobsStore.meta.pagination.total_pages,
                  "range-size": 1,
                  "onUpdate:modelValue": _ctx.updateHandler,
                  total: _ctx.jobsStore.meta.pagination.total_count,
                  from: _ctx.jobsStore.meta.pagination.from,
                  to: _ctx.jobsStore.meta.pagination.to
                }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setShowModal(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddTemplateToJob, {
          id: _ctx.selectedId,
          onReload: _cache[18] || (_cache[18] = () => _ctx.getAllResults(1)),
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setShowModal(false)))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showRecruiter,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setShowRecruiter(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddRecruiterToJob, {
          job: _ctx.dataJob,
          onReload: _cache[21] || (_cache[21] = () => _ctx.getAllResults(1)),
          onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setShowRecruiter(false)))
        }, null, 8, ["job"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showChallenge,
      onClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setShowChallenge(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddChallengeToJob, {
          id: _ctx.selectedId,
          onReload: _cache[24] || (_cache[24] = () => _ctx.getAllResults(1)),
          onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setShowChallenge(false)))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showCloseJob,
      onClose: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setShowCloseJob(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CloseJob, {
          id: _ctx.selectedId,
          onReload: _cache[27] || (_cache[27] = () => _ctx.getAllResults(1)),
          onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.setShowCloseJob(false)))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}